import { useTranslation } from "react-i18next";
import { Button } from "components/button";
import { Text } from "components/text";

interface TableEmptyStateProps {
  onGenerate: () => void | Promise<void>;
  isGenerating: boolean;
}

export const TableEmptyState = ({
  onGenerate,
  isGenerating,
}: TableEmptyStateProps) => {
  const { t } = useTranslation(["components", "general"]);

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 border border-secondary-200 bg-primary-25 rounded-xl bg-white">
      <div className="text-center space-y-4">
        <Text as="h3" variant="heading">
          {t("components:keywordsTab.unifiedKeywordsTable.empty.title")}
        </Text>
        <Text variant="muted" className="max-w-sm">
          {t("components:keywordsTab.unifiedKeywordsTable.empty.description")}
        </Text>
        <Button
          label={t(
            "components:keywordsTab.unifiedKeywordsTable.footer.generate",
          )}
          onClick={onGenerate}
          icon={isGenerating ? "loader" : "sparkles"}
          disabled={isGenerating}
          analyticsId="button_generate_keywords_empty"
        />
      </div>
    </div>
  );
};
